import React, {Component} from 'react'
import Plot from 'react-plotly.js';

class Graph extends Component {
    render() {
        console.log(this.props)
        return(
            <Plot
                data={[
                    {
                        x: [
                            1612084698996,
                            1612084702365,
                            1612084702462,
                            1612084702559,
                            1612084702659,
                            1612084702732,
                            1612084702841,
                            1612084702922,
                            1612084703028,
                            1612084703100,
                            1612084703205,
                            1612084703287,
                            1612084703384,
                            1612084703465,
                            1612084703562,
                            1612084703643,
                            1612084703740,
                            1612084703821,
                            1612084703918,
                            1612084703999,
                            1612084704089,
                            1612084704159,
                            1612084704249,
                            1612084704355,
                            1612084704420,
                            1612084704516,
                            1612084704612,
                            1612084704694,
                            1612084705036,
                            1612084705138,
                            1612084705268,
                            1612084705334,
                            1612084705455,
                            1612084705535,
                            1612084705641,
                            1612084705721,
                            1612084706168,
                            1612084706417,
                            1612084706701,
                            1612084706902,
                            1612084707009,
                            1612084707104
                        ],
                        y: [
                            1612085501432,
                            1612085501770,
                            1612085502053,
                            1612085502310,
                            1612085502650,
                            1612085502949,
                            1612085503314,
                            1612085503717,
                            1612085503816,
                            1612085503888,
                            1612085504043,
                            1612085504390,
                            1612085504455,
                            1612085504550,
                            1612085504615,
                            1612085505222,
                            1612085505562,
                            1612085505861,
                            1612085505861,
                            1612085505861,
                            1612085505861,
                            1612085505562,
                            1612085504615,
                            1612085504615,
                            1612085504615,
                            1612085504550,
                            1612085504550,
                            1612085504550,
                            1612085504550,
                            1612085503888,
                            1612085503888,
                            1612085503816,
                            1612085504615,
                            1612085504615,
                            1612085504615,
                            1612085509922,
                            1612085501432,
                            1612085501770,
                            1612085514957,
                            1612085513077,
                            1612085506256,
                            1612085500506
                        ],
                        type: 'scatter',
                        mode: 'lines+markers',
                        marker: {color: 'red'},
                    },
                ]}
                layout={ {width: 320, height: 400, title: 'Stress Levels'} }
            />
        )
    }
}

export default Graph;